import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const consentGivenAt = localStorage.getItem("consent_given_at");
        const res = await api.post("/auth/session", { session_id: sessionId, consent_given_at: consentGivenAt });
        localStorage.removeItem("consent_given_at");
        setUser(res.data);
        const back = localStorage.getItem("post_login_redirect");
        localStorage.removeItem("post_login_redirect");
        window.history.replaceState(null, "", "/dashboard");
        navigate(back?.startsWith("/") ? back : res.data.role === "admin" ? "/admin" : "/dashboard", { state: { user: res.data } });
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="text-center">
        <div className="h-10 w-10 border-2 border-[#D90429] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-sm uppercase tracking-[0.3em] text-[#A0A0A0]">Entering the studio</p>
      </div>
    </div>
  );
}
